<template>
  <form-capsule :formTitle="$t('suppliers.form_project_create_title')">
    <template slot="formcontent">
      <b-row>
        <b-col>
          <form-write-group-label-input v-model="name" isMandatory
            :inputLabel="$t('suppliers.project_name')"
            :mandatoryErrorIndicator="nameError">
          </form-write-group-label-input>
        </b-col>
        <b-col>
          <form-write-group-label-input v-model="groupIdentifier"
            :inputLabel="$t('suppliers.project_identifier')">
          </form-write-group-label-input>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="6">
          <form-write-group-label-input v-model="amountTotal" isMandatory
            inputType="number"
            :inputLabel="$t('suppliers.project_amountTotal')"
            :mandatoryErrorIndicator="amountTotalError">
          </form-write-group-label-input>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <form-write-group-label-input v-model="amountCredit"
            :inputLabel="$t('suppliers.project_amountCredit')"
            inputType="number">
          </form-write-group-label-input>
        </b-col>
        <b-col>
          <form-write-group-label-input v-model="amountDebit"
            inputType="number"
            :inputLabel="$t('suppliers.project_amountDebit')">
          </form-write-group-label-input>
        </b-col>
      </b-row>

      <b-row v-if="sellerList && sellerList.length > 0">
        <b-col sm="6">
          <form-write-group-label-input
            inputType="listeSelect"
            :inputLabel="$t('suppliers.supplier')">
            <select v-model="sellerId" class="form-control" readonly>
              <option value="">{{ $t('suppliers.slct_supplier') }}</option>
              <option v-for="seller in sellerList" :key="seller.IdSeller" :value="seller.IdSeller">
                {{ seller.SocialReason }}
              </option>
            </select>
          </form-write-group-label-input>
        </b-col>
      </b-row>

      <b-form-group>
        <b-row>
          <b-col class="form-group">
            <b-form-radio class="creationFormBtnRadio" v-model="marketplaceClientType"
              name="radios-marketplaceClientType" value="1">
              {{ $t('suppliers.slct_mpc') }}
            </b-form-radio>
          </b-col>
          <b-col>
            <form-write-group-label-input isMandatory
              inputType="listeSelect"
              :inputLabel="$t('suppliers.slct_mpc')" hiddenLabel
              :mandatoryErrorIndicator="marketplaceClientIdError">
              <select v-model="marketplaceClientId" class="form-control" id="sel2" readonly>
                <option value="">{{ $t('creation_forms.slct_a_mpc') }}</option>
                <option v-for="marketplaceClient in marketplaceClientList" :key="marketplaceClient.IdClient"
                        :value="marketplaceClient.IdClient">
                  {{ marketplaceClient.Identifier }}
                </option>
              </select>
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="form-group">
            <b-form-radio class="creationFormBtnRadio form-group" v-model="marketplaceClientType"
              name="radios-marketplaceClientType" value="2">
              {{ $t('suppliers.add_mpc') }}
            </b-form-radio>
          </b-col>
          <b-col>
            <form-write-group-label-input v-model="marketplaceClientUsername" isMandatory
              :inputLabel="$t('suppliers.marketplace_client_username')" hiddenLabel
              :placeholderValue="$t('suppliers.marketplace_client_username')"
              :mandatoryErrorIndicator="marketplaceClientUsernameError">
            </form-write-group-label-input>
          </b-col>
        </b-row>
      </b-form-group>
    </template>
    <template slot="footerbuttons">
      <b-row class="justify-content-start">
        <b-col md="3" offset-md="8">
          <button round
            class="button-action firstButtonMarginTop milkyBlockBlack"
            @click="createProject">
            <i class="icon fa fa-save"></i>
            {{ $t('suppliers.form_project_create_button') }}
          </button>
        </b-col>
      </b-row>
    </template>
  </form-capsule>
</template>
<script>
import moment from 'moment'
import formCapsule from '@/components/common/formCapsule.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import {verifyMandatoryValues, checkErrorFlag} from '@/helpers/validator'
/** @author JPR 26/08/2021
* @brief Component for adding Projects
*/
export default {
  name: 'CreateProjectForm',
  components: {
    'form-capsule': formCapsule,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  data () {
    return {
      amountCredit: '',
      amountDebit: '',
      amountTotal: '',
      amountTotalError: false,
      groupIdentifier: '',
      groupIdentifierError: false,
      marketplaceClientId: '',
      marketplaceClientIdError: false,
      marketplaceClientList: [],
      marketplaceClientType: '0',
      marketplaceClientUsername: '',
      marketplaceClientUsernameError: false,
      name: '',
      nameError: false,
      sellerId: '',
      sellerIdentifier: '',
      sellerList: []
    }
  },
  created () {
    let that = this
    this.$engine.services.suppliers.update(
      0,
      1000000,
      0
    ).then(resp => {
      that.sellerList = resp.data.Sellers
    }).catch(error => {
      errorMessageAlert(error, that, that.$i18n)
    })
    this.$engine.services.suppliers.getMarketplaceClient(
    ).then(resp => {
      that.marketplaceClientList = resp.data.Clients
    }).catch(error => {
      errorMessageAlert(error, that, that.$i18n)
    })
  },
  methods: {
    createProject () {
      if (!this.validateForm()) {
        this.$f7.alert(this.$i18n.t('errors.errors_in_form_details'), this.$i18n.t('errors.errors_in_form'))
        return
      }
      if (this.groupIdentifier === '') {
        this.groupIdentifier = 'GRP_' + moment().format('YYYYMMDDhhmmss') + '_' + Math.random().toString(36).substr(2, 6)
      }

      this.$f7.showPreloader(this.$i18n.t('loading.adding_project'))
      let that = this
      let jsonToCreate = {
        GroupIdentifier: this.groupIdentifier,
        Name: this.name,
        IdSeller: this.sellerId,
        // SellerIdentifier: this.sellerIdentifier,
        Amount: this.amountTotal,
        AmountCredit: this.amountCredit,
        AmountDebit: this.amountDebit
      }
      if (this.marketplaceClientId !== '') {
        jsonToCreate.IdMarketplaceClient = this.marketplaceClientId
      }
      this.$engine.services.suppliers.createGroup(jsonToCreate)
      .then(response => {
        that.status = response.status
        if (response.status === 200 || response.status === 201) {
          that.$f7.hidePreloader()
          that.$f7.modal({
            title: that.$i18n.t('success.project_added'),
            text: '<i class="icon fa fa-check"></i>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            that.$engine.services.suppliers.selectedSupplier.IdSeller = that.sellerId
            loadPage(that, { url: '/suppliers/details/' })
            // reloadPage(that, {url: '/inbox/', force: true, ignoreCache: true})
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    validateForm () {
      let flagsList = {}
      let mandatoryValues = ['amountTotal', 'name']
      /* IdSeller peut ne pas être obligatoire, potentiellement un if à ajouter */
      mandatoryValues.push('sellerId')
      /* Contrôle des champs selon un choix utilisateur */
      if (this.marketplaceClientType === '1' && this.marketplaceClientId === '') {
        this.marketplaceClientIdError = true
        flagsList.marketplaceClientId = true
        this.marketplaceClientUsernameError = false
        flagsList.marketplaceClientUsername = false
      } else if (this.marketplaceClientType === '2' && this.marketplaceClientUsername === '') {
        this.marketplaceClientUsernameError = true
        flagsList.marketplaceClientUsername = true
        this.marketplaceClientIdError = false
        flagsList.marketplaceClientId = false
      }
      /* Contrôle de liste */
      let idList = this.marketplaceClientList.map(obj => obj['IdClient']).filter((v, i, self) => i === self.indexOf(v))
      if (this.marketplaceClientId !== '' && !idList.includes(this.marketplaceClientId)) {
        this.marketplaceClientIdError = true
        flagsList.marketplaceClientId = true
      }
      flagsList = verifyMandatoryValues(mandatoryValues, flagsList, this)
      let errorFlag = checkErrorFlag(flagsList)
      return !errorFlag
    }
  }
}
</script>
